(async () => {
  const {
    updateURLParams,
    historyPush,
    parseHTML
  } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('product-form', class extends baseComponent.default {
    elements = {
      form: 'form',
      addButton: '[data-add-button]',
      buyButton: '[data-buy-button]',
      content: '[data-content]',
      input: '[data-variant-id-input]',
      sellingPlanInput: 'input[name="selling_plan"]'
    };
    async render() {
      this._enableInput();
      this.cartSection = document.querySelector('main-cart');
      this.isProductPage = this.getAttribute('page-type') === 'product';
  
  // === BANK HOLIDAY SUPPORT - Add this section ===
  // Fetch UK bank holidays automatically from gov.uk API
  var bankHolidays = [];
  var bankHolidaysLoaded = false;

  fetch('https://www.gov.uk/bank-holidays.json')
    .then(response => response.json())
    .then(data => {
      // Get England & Wales bank holidays
      bankHolidays = data['england-and-wales'].events.map(event => event.date);
      bankHolidaysLoaded = true;
      console.log('✅ Bank holidays loaded:', bankHolidays.length, 'holidays');
    })
    .catch(error => {
      console.warn('⚠️ Could not load bank holidays, using weekends only');
    });

  function isBankHoliday(date) {
    if (!bankHolidaysLoaded) return false;
    var dateStr = date.toString('yyyy-MM-dd');
    return bankHolidays.indexOf(dateStr) !== -1;
  }

  function isWorkingDay(date) {
    return !date.is().saturday() && !date.is().sunday() && !isBankHoliday(date);
  }

  function getNextWorkingDay(fromDate) {
    var nextDay = fromDate.clone().addDays(1);
    while (!isWorkingDay(nextDay)) {
      nextDay = nextDay.addDays(1);
    }
    return nextDay;
  }
  // === END BANK HOLIDAY SUPPORT ===

      this.listenTo('variantChange', (e, data) => {
        this._rerender(data);
        if (data.variant) {
          this._rerenderVariantInput(data)
        }
      });
      this.on('cartChange', (e, data) => {
        this._updateQtyStatus(data.variantId)
      }, false)
      if (this.hasAttribute('cart-popup'))
        this.$form.addEventListener('submit', this._handleSubmit.bind(this));
      
      if (this.$sellingPlanInput && this.hasAttribute('selling-plan-enable')) {
        this.currentSellingPlanId = this.querySelector('input[name="selling_plan"]').value;
        const {observeInputValueChange} = await import(window.theme.modules.sellingPlanUtil);
        observeInputValueChange(this.$sellingPlanInput, this._handleSellingPlanChange.bind(this));
      }

      var delivery_timeEl = document.querySelector('.delivery_time');
      if(delivery_timeEl) {
           function msToTime() {  

            var  order_time =  delivery_timeEl.getAttribute('data-order_time');
            var  order_time_end_day = '11:59:59pm';
            var order_time_hours = order_time.replace("am","").replace("pm","").split(":")[0] * (60000 * 60);
            var order_time_minutes = order_time.replace("am","").replace("pm","").split(":")[0] * 60000;
			var order_next_day_time = order_time_hours + order_time_minutes; 
            if(order_time.indexOf("pm") != -1){
              order_next_day_time = order_next_day_time + (59800 * 60 * 10);
            }
            
            var cutoff_time = Date.today().at(order_time);
   			var  cutoff_time_end_day = Date.today().at(order_time_end_day);

            var current_time = new Date().toLocaleTimeString('en-GB', { 
            timeZone: 'Europe/London',
            hour12: true 
            }); // time zone London

            current_time = Date.parse(current_time); // convert time to date.js
            var hourDiff = cutoff_time - current_time; //in ms
            var seconds = parseInt((hourDiff / 1000) % 60),
                minutes = parseInt((hourDiff / (1000 * 60)) % 60),
                hours = parseInt((hourDiff / (1000 * 60 * 60)) % 24);

            if(hourDiff > 0 && isWorkingDay(cutoff_time)) { 
                  if(hours != 0) {
                    delivery_timeEl.innerHTML = 'Order in the next ' +  hours+ ' hours ' + minutes + ' minutes ' + seconds + ' seconds for same day despatch.';
                  } else {
                     delivery_timeEl.innerHTML = 'Order in the next '+ minutes + ' minutes ' + seconds + ' seconds for same day despatch.';
                  }
                } else { 
  current_time = Date.parse(current_time); // convert time to date.js
  
  // Find the next working day for despatch
   var current_time_beforeMonday = Date.today().at(order_time).addDays(1);
  while (!isWorkingDay(current_time_beforeMonday)) {
    current_time_beforeMonday = current_time_beforeMonday.addDays(1);
  }
  
  // Get the day name (while it's still a Date object)
  var nextWorkingDayName = current_time_beforeMonday.toString('dddd');
  var daysUntilDispatch = Math.floor((current_time_beforeMonday - Date.today()) / (1000 * 60 * 60 * 24));
  
  // NOW parse it to a number
  current_time_beforeMonday = Date.parse(current_time_beforeMonday);
  
  var hourDiff = current_time_beforeMonday - Date.parse(current_time);
  var seconds = parseInt((hourDiff / 1000) % 60),
      minutes = parseInt((hourDiff / (1000 * 60)) % 60),
      hours = parseInt((hourDiff / (1000 * 60 * 60)) % 24),
      days = parseInt(hourDiff / (1000 * 60 * 60 * 24));
  
  // Build the message
  var timeMessage = 'Order in the next ';
  if(days > 0) {
    timeMessage += days + ' day' + (days > 1 ? 's ' : ' ');
  }
  if(hours > 0) {
    timeMessage += hours + ' hour' + (hours > 1 ? 's ' : ' ');
  }
  timeMessage += minutes + ' minute' + (minutes > 1 ? 's ' : ' ');
  timeMessage += seconds + ' second' + (seconds > 1 ? 's' : '');
  
  // Use day name if more than 1 day away, otherwise say "tomorrow"
  if(days > 1) {
    timeMessage += ' for despatch on ' + nextWorkingDayName + '.';
  } else {
    timeMessage += ' for despatch tomorrow.';
  }
  
  delivery_timeEl.innerHTML = timeMessage;
}
  
          }
          msToTime();
          var timerIdProduct = setInterval(function() {
            msToTime();
          }, 1000);
      }
      console.log(delivery_timeEl);
    };
    
    _handleSellingPlanChange(newSellingPlanId) {
      if (newSellingPlanId === this.currentSellingPlanId) 
        return;      
      this.currentSellingPlanId = newSellingPlanId;
      const { queryURL, currentURL } = updateURLParams({ 'selling_plan': this.currentSellingPlanId, 'variant': this.getAttribute('current-variant') }, this.sectionId);
      if (this.isProductPage)
        historyPush(currentURL);
      this._fetchPageWithVariant(queryURL, html => {
        this.forwardEvent('sellingPlanChange', {
          html: html
        })
      }); 
    };

    _enableInput() {
      this.$input.disabled = false;
    }
    
    _fetchPageWithVariant(url, onResponse) {
      return fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = parseHTML(responseText)
        onResponse(html);
      });
    };

    _rerender(data) {
      const source = data.html.querySelector(`#${this.getAttribute('form-id')} [data-content]`);
      this.$content.replaceChildren(...source.cloneNode(true).childNodes);
      this._rerenderPaymentButton();
    };
    _rerenderVariantInput(data) {
      this.setAttribute('current-variant', `${data.variant.id}`);
      const value = data.html.querySelector(this.elements.input).value;
      this.$input.value = value;
    };
    _rerenderPaymentButton() {
      if (window.Shopify?.PaymentButton?.init) {
        window.Shopify.PaymentButton.init();
      }
    };
    _handleSubmit(e) {
      e.preventDefault();
      this.formData = new FormData(e.target);
      this._addToCartRequest();
    };

    _addToCartRequest() {
      this._setLoading(true);
      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          "Accept": "application/javascript"
        },
        body: this.formData
      })
      .then(res => {
        return res.json();
      })
      .then(() => {
        this.trigger('updateCart', {
          callback: () => {
            this._setLoading(false);
            this._updateQtyStatus(this.formData.get('id'));
            if(this.cartSection) {
              this.cartSection.update();
            } else {
              this.trigger('openPopup', { target: 'CART' });
            }
          }
        })
      })
      .catch(error => {
        this._setLoading(false);
        console.log(error);
      });
    };

    _updateQtyStatus(variantId) {
      const url = `${this.getAttribute('product-url')}?variant=${variantId}&section_id=${this.getAttribute('section-id')}`;
      this._fetchPageWithVariant(url, html => {
        this.trigger('qtyStatusUpdate', {html: html, variantId: variantId})
        this._rerender({html: html})
      })
    };
    
    _setLoading(status) {
      status 
        ? this.$addButton.setAttribute('loading', '')
        : this.$addButton.removeAttribute('loading');
      // status ? this.$addButton.setAttribute('disabled', true) :
      //   this.$addButton.removeAttribute('disabled');
      // this.$addButton.textContent = status ? window.theme.i18n.loading : window.theme.i18n.addToCart;
    };
  });
})();